// ─────────────────────────────────────────────────────────────────────────────
// 2026-10-14 — Libros Excel de Reportería generados en el servidor (réplica de la opción B de Brillamos
// Juntos al resto de los reportes; REPORTERIA-REGLAS §23).
//
// Con `VITE_REPORTES_EXCEL_BACKEND='true'` el navegador ya no arma el archivo con exceljs: manda las
// hojas (las MISMAS `ExcelSheetSpec` de siempre) a SurveyService y descarga el `.xlsx` que responde.
// Apagado o ausente, `exportMultiSheetExcel` como antes: es la reversa sin tocar el backend.
//
// Brillamos Juntos tiene su propio interruptor (`VITE_BRILLAMOS_EXCEL_BACKEND`, `ShineTab.tsx`).
// ─────────────────────────────────────────────────────────────────────────────
import { RecognitionApiError, reportExcelApi } from '@/api/recognition';
import { exportMultiSheetExcel } from '@/utils/exportExcelMultiSheet';
import type { ExcelReportSpec } from '@/utils/exportExcelMultiSheet';
import { descargarBlobComoExcel } from '@/utils/excelDownload';

const EXTENSION_EXCEL = '.xlsx';

/**
 * 2026-10-19 — clave del aviso cuando falla una descarga de Reportería. Sin tope de 5000 filas, el único
 * límite es la salvaguarda del servidor (422 a partir de 200 000 filas por hoja): se dice qué pasó y
 * qué hacer, en vez del error genérico.
 */
export function claveDeErrorDeExportacion(error: unknown): string {
  return error instanceof RecognitionApiError && error.status === 422
    ? 'reports.shine.exportTooLarge'
    : 'reports.shine.exportError';
}

/** ¿Los libros de Reportería (salvo Brillamos Juntos) se generan en el servidor? Se lee en cada llamada. */
export function reportesExcelEnServidor(): boolean {
  return import.meta.env.VITE_REPORTES_EXCEL_BACKEND === 'true';
}

/** Mismo criterio que `exportMultiSheetExcel`: agrega `.xlsx` si falta. */
export function nombreDeDescarga(fileName: string): string {
  return fileName.endsWith(EXTENSION_EXCEL) ? fileName : `${fileName}${EXTENSION_EXCEL}`;
}

/**
 * Descarga un libro de agregados (Demográfico, Históricos, Líderes, Moderación). Con el interruptor
 * encendido lo escribe el servidor (`POST v1/report-excel/render`); si no, el navegador.
 */
export async function exportarLibro(spec: ExcelReportSpec): Promise<void> {
  if (!reportesExcelEnServidor()) {
    await exportMultiSheetExcel(spec);
    return;
  }
  const blob = await reportExcelApi.render({ fileName: spec.fileName, hojas: spec.sheets });
  descargarBlobComoExcel(blob, nombreDeDescarga(spec.fileName));
}
